var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDebtCollectionWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "38px",
    viewBox: "0 0 32 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ikon_inkasso_hvit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Elementer-med-oppf\\xF8rsel",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementer",
    transform: "translate(-1939.000000, -2131.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ikon_inkasso_hvit",
    transform: "translate(1939.000000, 2131.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ikon_inkasso-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-15",
    x: 0.75,
    y: 0.75,
    width: 30.5,
    height: 36.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-3",
    cx: 16,
    cy: 19.5,
    rx: 5,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,11 C21,9 18.5,7 16,7 C13.5,7 11,9 11,11 C11,13 13.5,15 16,15",
    id: "Path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,28 C21,26 18.5,24 16,24 C13.5,24 11,26 11,28 C11,30 13.5,32 16,32",
    id: "Path-2",
    transform: "translate(16.000000, 28.000000) scale(-1, -1) translate(-16.000000, -28.000000) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebtCollectionWhite);
export default __webpack_public_path__ + "static/media/debt-collection-white.f584ae9c92be3f301324208dd6d24b5f.svg";
export { ForwardRef as ReactComponent };